import { ServiceAppService } from "../../../security/service-app.service";
import { FileUpload } from "../../../shared/fileupload/fileupload";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MessageService } from "primeng/api";
import { ListaCargas } from "../interfaces/lista-cargas";
import { InfoCarga } from "../interfaces/info-carga";

@Component({
  selector: "app-carga-gwm-lista",
  templateUrl: "./carga-gwm-lista.component.html",
  styleUrls: ["./carga-gwm-lista.component.css"],
})
export class CargaGWMListaComponent implements OnInit {
  displayImport: boolean = false;
  totalPercent = 0;
  progressBarPerc: any;
  percentDone: number;
  progress = false;
  acompanharCarga: any[];
  detalhes: any;
  exibirDetalhes: boolean = false;
  respostaUpload: boolean = true;
  listaUpload: ListaCargas[] = [];
  infoCargaList: InfoCarga[] = [];
  statusMsg: any;
  arquivoStatus: any;
  resultProc: any;
  uploader: FileUpload;
  arquivoInvalido: any[];
  arquivoSucesso: any[];
  falhaUpload: any[];
  arquivosInvalidos: string[] = [];
  display: boolean = false;
  loading: boolean;
  first = 0;
  rows = 10;
  dados: any[];
  marcas: any;
  envioAgregado: boolean = false;

  exibirDialogErro: boolean = false;
  erroTitulo: string = "";
  erroDetalhado: string = "";

  obrigatorios = [
    "CADASTRO_MODELO",
    "MODELO_COR",
    "MODELO_ACABAMENTO",
    "CADASTRO_SALES_CODE",
  ];

  gwmArquivosObrigatorios = [
    "CNPJ_HOMOLOGADO",
    "LEAD_TIME_UF",
    "CLASSES_PRODUTOS",
  ];

  @ViewChild("fileUploader") fileUpload: FileUpload;

  constructor(
    private messageService: MessageService,
    private service: ServiceAppService
  ) {}

  ngOnInit(): void {
    this.service.getDados(`/admin/capturarMarca`).subscribe((res) => {
      const marca = res.nome;
      if (marca.includes("GWM")) {
        this.marcas = "NHS";
        console.log(this.marcas);
      }
    });

    this.progressBarPerc = 0;

    this.listagemUpload();
    this.carregarParametros();
  }

  showMensagemStatus() {
    this.display = true;
  }

  carregarParametros() {
    this.service.getDados("/cadastrar_fabrica/parametros").subscribe({
      next: (res) => {
        this.envioAgregado = res.envio_agregado;
      },
      error: (error) => {
        this.envioAgregado = false;
        console.warn("Erro ao carregar parâmetros:", error);
      },
    });
  }

  showDialog() {
    this.displayImport = true;
  }

  progressReport(event) {
    this.fileUpload.progress = event;
  }

  onRemoveFile($event) {
    if ($event && $event.files && $event.files.length == 0) {
      this.progressBarPerc = 0;
    }
  }

  onSelectFile(event: FileUpload) {
    this.progressBarPerc = 0;
  }

  removeFile(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
  }

  removerArquivos(files: File[], uploader: FileUpload) {
    for (const file of files) {
      const index = uploader?.files?.indexOf(file);
      if (index !== -1) {
        uploader?.remove(null, index);
      }
    }
  }

  private obterPrefixoArquivo(fileName: string): string {
    const nomeSemExt = fileName.replace(/\.csv$/i, "");
    const idx = nomeSemExt.lastIndexOf("_");

    return idx !== -1 ? nomeSemExt.substring(0, idx) : nomeSemExt;
  }

  private obterDataArquivo(fileName: string): string {
    const match = fileName.match(/_(\d{6})\.csv$/i);

    return match ? match[1] : "";
  }

  private obterNomeArquivoCarga(item: any): string {
    return (
      item?.nomeArquivo ||
      item?.nome_arquivo ||
      item?.arquivo ||
      item?.nome ||
      item?.name ||
      item?.fileName ||
      item?.filename ||
      ""
    );
  }

  private arquivoJaExisteNaListagem(fileName: string): boolean {
    const nomeArquivo = fileName.toLowerCase();

    return (this.listaUpload || []).some((item) => {
      const nomeListado = this.obterNomeArquivoCarga(item).toLowerCase();

      if (nomeListado && nomeListado === nomeArquivo) {
        return true;
      }

      try {
        return JSON.stringify(item).toLowerCase().includes(nomeArquivo);
      } catch (e) {
        return false;
      }
    });
  }

  private validarTresArquivosGwmJaEnviados(gwmFiles: File[]): string[] {
    const arquivosJaEnviados = gwmFiles
      .filter((file) => this.arquivoJaExisteNaListagem(file.name))
      .map((file) => file.name);

    return arquivosJaEnviados.length === 3 ? arquivosJaEnviados : [];
  }

  private montarMensagemErroUpload(handler: any, fileName?: string): string {
    console.log("Erro completo do upload:", handler);

    let erroBruto: any =
      handler?.error?.erro ||
      handler?.error?.message ||
      handler?.error?.statusMessage ||
      handler?.error ||
      handler?.message ||
      handler?.statusText ||
      handler;

    if (typeof erroBruto === "string") {
      try {
        const erroJson = JSON.parse(erroBruto);

        erroBruto =
          erroJson?.erro ||
          erroJson?.message ||
          erroJson?.statusMessage ||
          erroBruto;
      } catch (e) {
        // mantém como texto normal
      }
    }

    if (typeof erroBruto !== "string") {
      try {
        erroBruto =
          erroBruto?.erro ||
          erroBruto?.message ||
          erroBruto?.statusMessage ||
          JSON.stringify(erroBruto);
      } catch (e) {
        erroBruto = "Erro desconhecido ao enviar arquivo.";
      }
    }

    const erro = erroBruto || "Erro desconhecido ao enviar arquivo.";
    const erroLower = erro.toLowerCase();
    const arquivo = fileName ? `${fileName}: ` : "";

    if (
      erroLower.includes("já foi processado") ||
      erroLower.includes("ja foi processado") ||
      erroLower.includes("processado com sucesso") ||
      erroLower.includes("já existe") ||
      erroLower.includes("ja existe") ||
      erroLower.includes("arquivo repetido") ||
      erroLower.includes("duplicado")
    ) {
      return `${arquivo}este arquivo já foi enviado/processado anteriormente. Verifique se ele já aparece na listagem de cargas antes de tentar enviar novamente. Detalhe: ${erro}`;
    }

    if (
      erroLower.includes("header") ||
      erroLower.includes("cabeçalho") ||
      erroLower.includes("cabecalho") ||
      erroLower.includes("esperado:")
    ) {
      return `${arquivo}header inválido. Verifique se o cabeçalho do CSV está exatamente no padrão esperado. Detalhe: ${erro}`;
    }

    if (
      erroLower.includes("conteúdo") ||
      erroLower.includes("conteudo") ||
      erroLower.includes("linha") ||
      erroLower.includes("coluna") ||
      erroLower.includes("deve possuir") ||
      erroLower.includes("inválido") ||
      erroLower.includes("invalido")
    ) {
      return `${arquivo}verifique o conteúdo do arquivo. Existem linhas ou colunas fora do padrão esperado. Detalhe: ${erro}`;
    }

    if (
      handler?.status === 405 ||
      erroLower.includes("405") ||
      erroLower.includes("method not allowed")
    ) {
      return `${arquivo}método não permitido para o endpoint de upload. Confirme se a tela está chamando o endpoint correto. Detalhe: ${erro}`;
    }

    if (
      handler?.status === 500 ||
      erroLower.includes("internal server error")
    ) {
      return `${arquivo}erro interno no processamento da carga. Detalhe retornado pelo servidor: ${erro}`;
    }

    return `${arquivo}${erro}`;
  }

      private exibirErroUpload(handler: any, fileName: string): void {
    const mensagem =
      handler?.error?.erro ||
      handler?.error?.message ||
      handler?.message ||
      "Erro desconhecido ao enviar arquivo.";

    if (mensagem.split("\n").length > 2) {
      this.erroTitulo = fileName;
      this.erroDetalhado = mensagem;
      this.exibirDialogErro = true;
      return;
    }

    this.messageService.add({
      key: "carga",
      severity: "warn",
      summary: "Erro no upload",
      detail: `${fileName}: ${mensagem}`,
      life: 9000,
    });
  }

   
  fecharDialogErro(): void {
    this.exibirDialogErro = false;
    this.erroTitulo = "";
    this.erroDetalhado = "";
  }

  copiarErro(): void {
    navigator.clipboard.writeText(this.erroDetalhado).then(
      () => {
        this.messageService.add({
          key: "carga",
          severity: "success",
          summary: "Copiado",
          detail: "Lista de erros copiada para a área de transferência.",
          life: 3000,
        });
      },
      () => {
        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Não foi possível copiar",
          detail: "Selecione o texto e copie manualmente.",
          life: 4000,
        });
      }
    );
  }

  async onUpload(event) {
    try {
      this.progress = true;
      this.arquivoInvalido = [];

      const errosNomenclatura = [];
      const arquivosRepetidos = [];
      const arquivosSucesso = [];

      this.messageService.add({
        key: "carga",
        severity: "info",
        summary: "Importando...",
        detail:
          "Aguarde o término da importação, pode fechar a tela e voltar mais tarde!",
        life: 2000,
      });

      if (this.envioAgregado) {
        const nomesSelecionados = event.files.map((f) =>
          this.obterPrefixoArquivo(f.name)
        );

        const faltantes = this.obrigatorios.filter(
          (ob) => !nomesSelecionados.includes(ob)
        );

        if (
          nomesSelecionados.some((nome) => this.obrigatorios.includes(nome)) &&
          faltantes.length > 0
        ) {
          this.messageService.add({
            key: "carga",
            severity: "warn",
            summary: "Arquivos faltando",
            detail: `Para enviar um desses arquivos é obrigatório enviar os 4 juntos. Faltando: ${faltantes.join(
              ", "
            )}`,
            life: 7000,
          });

          return;
        }
      }

      const validFiles = [];
      const gwmFiles = [];

      for (let i = 0; i < event.files.length; i++) {
        const file = event.files[i];
        const fileName = file.name;

        const pattern =
          /^(MOBILIDADE|CADASTRO_MODELO|MODELO_COR|SIMILARES|MODELO_ACABAMENTO|CADASTRO_TMO|KIT_REV_MANUT|CAMPANHA_RECALL|CADASTRO_SALES_CODE|CHASSI_RECALL_REALIZADO|CHASSI_RECALL|TRANQUILIDADE|REVISAO_GRATUITA|CNPJ_HOMOLOGADO|LEAD_TIME_UF|CLASSES_PRODUTOS|PEDIDOS_FATURADOS|ITENS_SUBSIDIO|PRECO_PECAS_[A-Za-z0-9]+)_(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])\d{2}\.csv$/i;

        const arquivosPermitidos = [
          "Base_Retail",
          "PAGAMENTO_GARANTIA",
          "Brazil_Handed_Over_Assets_with_Service_Plans",
          "Brazil_smp_claims",
          "Cadastro_marcas",
        ];

        const isCsv = fileName.toLowerCase().endsWith(".csv");

        const isExcecaoPermitida = arquivosPermitidos.some((nome) =>
          fileName.toLowerCase().includes(nome.toLowerCase())
        );

        if (isExcecaoPermitida && isCsv) {
          // permite envio
        } else if (!pattern.test(fileName)) {
          errosNomenclatura.push(fileName);
          continue;
        }

        const prefix = this.obterPrefixoArquivo(fileName);

        if (this.gwmArquivosObrigatorios.includes(prefix)) {
          gwmFiles.push(file);
        } else {
          validFiles.push(file);
        }
      }

      if (gwmFiles.length > 0) {
        const tiposSelecionadosGwm = gwmFiles.map((file) =>
          this.obterPrefixoArquivo(file.name)
        );

        const tiposUnicosGwm = Array.from(new Set(tiposSelecionadosGwm));

        const faltantesGwm = this.gwmArquivosObrigatorios.filter(
          (tipo) => !tiposUnicosGwm.includes(tipo)
        );

        const repetidosGwm = this.gwmArquivosObrigatorios.filter(
          (tipo) =>
            tiposSelecionadosGwm.filter((item) => item === tipo).length > 1
        );

        const datasGwm = Array.from(
          new Set(
            gwmFiles
              .map((file) => this.obterDataArquivo(file.name))
              .filter((data) => data)
          )
        );

        if (faltantesGwm.length > 0) {
          this.messageService.add({
            key: "carga",
            severity: "warn",
            summary: "Envie os 3 arquivos juntos",
            detail: `Essa carga precisa ser enviada com os 3 arquivos no mesmo upload: CNPJ_HOMOLOGADO, LEAD_TIME_UF e CLASSES_PRODUTOS. Faltando: ${faltantesGwm.join(
              ", "
            )}.`,
            life: 8000,
          });

          return;
        }

        if (repetidosGwm.length > 0) {
          this.messageService.add({
            key: "carga",
            severity: "warn",
            summary: "Arquivos duplicados",
            detail: `Envie apenas um arquivo de cada tipo para a carga GWM. Duplicado(s): ${repetidosGwm.join(
              ", "
            )}.`,
            life: 8000,
          });

          return;
        }

        if (datasGwm.length > 1) {
          this.messageService.add({
            key: "carga",
            severity: "warn",
            summary: "Datas diferentes",
            detail: `Os 3 arquivos da carga GWM precisam possuir a mesma data no nome. Datas encontradas: ${datasGwm.join(
              ", "
            )}.`,
            life: 8000,
          });

          return;
        }

        const arquivosGwmJaEnviados =
          this.validarTresArquivosGwmJaEnviados(gwmFiles);

        if (arquivosGwmJaEnviados.length === 3) {
          this.messageService.add({
            key: "carga",
            severity: "warn",
            summary: "Carga GWM já enviada",
            detail: `Os 3 arquivos desta carga GWM já foram enviados anteriormente: ${arquivosGwmJaEnviados.join(
              ", "
            )}. Verifique a listagem de cargas antes de enviar novamente.`,
            life: 9000,
          });

          return;
        }

        const formData = new FormData();
        gwmFiles.forEach((file) => formData.append("file", file));

        try {
          await this.service
            .postArquivo("/carga_montadora/upload", formData)
            .toPromise();

          gwmFiles.forEach((file) => arquivosSucesso.push(file.name));

          gwmFiles.forEach((file) => {
            const idx = event.files.indexOf(file);
            if (idx !== -1) {
              event.files.splice(idx, 1);
            }
          });
        } catch (error) {
          await this.exibirErroUpload(error, "Carga GWM");

          gwmFiles.forEach((file) => {
            const idx = event.files.indexOf(file);
            if (idx !== -1) {
              event.files.splice(idx, 1);
            }
          });
        }
      }

      for (const file of validFiles) {
        const fileName = file.name;
        const formData = new FormData();

        formData.append("file", file);

        try {
          await this.service
            .postArquivoItem("/carga_montadora/upload", formData)
            .toPromise();

          arquivosSucesso.push(fileName);

          const idx = event.files.indexOf(file);
          if (idx !== -1) {
            event.files.splice(idx, 1);
          }
        } catch (handler) {
          await this.exibirErroUpload(handler, fileName);

          const idx = event.files.indexOf(file);
          if (idx !== -1) {
            event.files.splice(idx, 1);
          }
        }
      }

      if (errosNomenclatura.length > 0) {
        const message = `O(s) seguinte(s) arquivo(s) não segue(m) o padrão de nome correto: ${errosNomenclatura.join(
          ", "
        )}. Verifique o nome e envie novamente no formato esperado.`;

        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Nome de arquivo inválido",
          detail: message,
          life: 7000,
        });

        this.removerArquivos(
          event.files.filter((file) => errosNomenclatura.includes(file.name)),
          this.fileUpload
        );
      }

      if (arquivosRepetidos.length > 0) {
        const message = `O(s) seguinte(s) arquivo(s) ja existe(m) no banco de dados: ${arquivosRepetidos.join(
          ", "
        )}`;

        this.messageService.add({
          key: "carga",
          severity: "warn",
          summary: "Arquivo já enviado",
          detail: message,
          life: 7000,
        });

        this.removerArquivos(
          event.files.filter((file) => arquivosRepetidos.includes(file.name)),
          this.fileUpload
        );
      }

      if (arquivosSucesso.length > 0) {
        const message = `${arquivosSucesso.length} arquivo(s) enviado(s) com sucesso`;

        this.messageService.add({
          key: "carga",
          severity: "success",
          summary: "Sucesso",
          detail: message,
          life: 3000,
        });

        this.progressBarPerc = 100;

        setTimeout(() => {
          this.recarregarDados();
          this.progressBarPerc = 0;
        }, 3000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.progress = false;
    }
  }

  listagemUpload() {
    this.service.getDados("/carga_montadora/listar").subscribe((res) => {
      this.listaUpload = res.dados.map((item) => {
        const data = new Date(item.data);

        const fimProcessamento = item.fimProcessamento
          ? new Date(item.fimProcessamento)
          : null;

        const inicioProcessamento = item.inicioProcessamento
          ? new Date(item.inicioProcessamento)
          : null;

        const diferenca =
          fimProcessamento && inicioProcessamento
            ? fimProcessamento.getTime() - inicioProcessamento.getTime()
            : 0;

        const horas = Math.floor(diferenca / 3600000);
        const minutos = Math.floor((diferenca % 3600000) / 60000);
        const segundos = Math.floor(((diferenca % 3600000) % 60000) / 1000);

        this.loading = false;

        return {
          ...item,
          data: data.getTime(),
          dataConvertida: data.toLocaleDateString(),
          hora: `${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`,
          fimProcessamento: fimProcessamento
            ? fimProcessamento.toLocaleDateString()
            : "00:00:00",
          horaFimProcessamento: fimProcessamento
            ? `${fimProcessamento
                .getHours()
                .toString()
                .padStart(2, "0")}:${fimProcessamento
                .getMinutes()
                .toString()
                .padStart(2, "0")}:${fimProcessamento
                .getSeconds()
                .toString()
                .padStart(2, "0")}`
            : "00:00:00",
          inicioProcessamento: inicioProcessamento
            ? inicioProcessamento.toLocaleDateString()
            : "00:00:00",
          horaInicioProcessamento: inicioProcessamento
            ? `${inicioProcessamento
                .getHours()
                .toString()
                .padStart(2, "0")}:${inicioProcessamento
                .getMinutes()
                .toString()
                .padStart(2, "0")}:${inicioProcessamento
                .getSeconds()
                .toString()
                .padStart(2, "0")}`
            : "00:00:00",
          diferencaHorario: `${horas.toString().padStart(2, "0")}:${minutos
            .toString()
            .padStart(2, "0")}:${segundos.toString().padStart(2, "0")}`,
        };
      });

      this.listaUpload = this.listaUpload.map((upload) => ({
        ...upload,
        statusString:
          upload.status === 0
            ? "Pendente"
            : upload.status === 1
            ? "Sucesso"
            : upload.status === 2
            ? "Processando"
            : upload.status === 3
            ? "Erro"
            : "Pendente p/ Validação",
      }));

      console.log("Lista de uploads carregada:", this.listaUpload);

      this.loading = false;
    });
  }

  mostrarDetalhes(item: any) {
    this.buscarIdArquivo(item.id);
    this.exibirDetalhes = true;
  }

  buscarIdArquivo(item) {
    this.service
      .getDados("/carga_montadora/listar/detalhe?id_arquivo=" + item)
      .subscribe((res) => {
        this.infoCargaList = res.dealers;
        this.arquivoStatus = res.status;
        this.statusMsg = res.msg;
      });
  }

  fecharDetalhes() {
    this.exibirDetalhes = false;
    this.listagemUpload();
    this.progressBarPerc = 0;
  }

  recarregarDados() {
    this.loadCustomers();
  }

  loadCustomers() {
    this.loading = true;

    setTimeout(() => {
      this.listagemUpload();
    });
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dados ? this.first === this.dados.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.dados ? this.first === 0 : true;
  }

  baixarArquivo(event: Event, name: string): void {
    event.preventDefault();

    this.service
      .downloadExcelFile(
        `/carga_montadora/downloadMontadora?nomeArquivo=${name}`
      )
      .subscribe(
        (blob) => {
          const a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(window.URL.createObjectURL(blob));
        },
        (error) => {
          this.messageService.add({
            key: "carga",
            severity: "warn",
            summary: "Erro",
            detail: `O arquivo foi removido, pois um arquivo mais recente foi encontrado!`,
            life: 3000,
          });
        }
      );
  }
}